import React, { useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import {
	Badge,
	Box,
	Button,
	Chip,
	Container,
	IconButton,
	Paper,
	Stack,
	TextField,
	Typography,
	Tooltip,
	Avatar,
	Divider,
	Snackbar,
	Grid,
} from "@mui/material";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import CallEndIcon from "@mui/icons-material/CallEnd";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import ScreenShareIcon from "@mui/icons-material/ScreenShare";
import StopScreenShareIcon from "@mui/icons-material/StopScreenShare";
import ChatIcon from "@mui/icons-material/Chat";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SendIcon from "@mui/icons-material/Send";
import CloseIcon from "@mui/icons-material/Close";
import PeopleIcon from "@mui/icons-material/People";
import server from "../environment";
import styles from "../styles/videoComponent.module.css";

const server_url = server;
var connections = {};

const peerConfigConnections = {
	iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
};

export default function VideoMeetComponent() {
	var socketRef = useRef();
	let socketIdRef = useRef();
	let localVideoref = useRef();

	let [videoAvailable, setVideoAvailable] = useState(true);
	let [audioAvailable, setAudioAvailable] = useState(true);
	let [video, setVideo] = useState(true);
	let [audio, setAudio] = useState(true);
	let [screen, setScreen] = useState(false);
	let [showModal, setModal] = useState(false); // Default to chat closed in Google Meet
	let [screenAvailable, setScreenAvailable] = useState();
	let [messages, setMessages] = useState([]);
	let [message, setMessage] = useState("");
	let [newMessages, setNewMessages] = useState(0);
	let [askForUsername, setAskForUsername] = useState(true);
	let [username, setUsername] = useState("");
	let [videos, setVideos] = useState([]);
	let [participantNames, setParticipantNames] = useState({});

	// UI enhancements
	let [snackbarOpen, setSnackbarOpen] = useState(false);
	let [snackbarMessage, setSnackbarMessage] = useState("");
	let [clockTime, setClockTime] = useState("");

	const videoRef = useRef([]);

	// Live clock update
	useEffect(() => {
		const updateTime = () => {
			const timeStr = new Date().toLocaleTimeString([], {
				hour: "2-digit",
				minute: "2-digit",
			});
			setClockTime(timeStr);
		};
		updateTime();
		const timer = setInterval(updateTime, 1000 * 30);
		return () => clearInterval(timer);
	}, []);

	useEffect(() => {
		getPermissions();
	}, []);

	let getDislayMedia = () => {
		if (screen) {
			if (navigator.mediaDevices.getDisplayMedia) {
				navigator.mediaDevices
					.getDisplayMedia({ video: true, audio: true })
					.then(getDislayMediaSuccess)
					.then((stream) => {})
					.catch((e) => console.log(e));
			}
		}
	};

	const getPermissions = async () => {
		try {
			setScreenAvailable(!!navigator.mediaDevices.getDisplayMedia);

			try {
				window.localStream?.getTracks?.().forEach((t) => t.stop());
			} catch (e) {}

			let stream = null;
			let videoOk = false;
			let audioOk = false;

			try {
				stream = await navigator.mediaDevices.getUserMedia({
					video: true,
					audio: true,
				});
				videoOk = true;
				audioOk = true;
			} catch (e) {
				try {
					stream = await navigator.mediaDevices.getUserMedia({
						video: true,
						audio: false,
					});
					videoOk = true;
					audioOk = false;
				} catch {
					try {
						stream = await navigator.mediaDevices.getUserMedia({
							video: false,
							audio: true,
						});
						videoOk = false;
						audioOk = true;
					} catch {
						stream = null;
						videoOk = false;
						audioOk = false;
					}
				}
			}

			setVideoAvailable(videoOk);
			setAudioAvailable(audioOk);
			setVideo(videoOk);
			setAudio(audioOk);

			if (stream) {
				window.localStream = stream;
				if (localVideoref.current) {
					localVideoref.current.srcObject = stream;
				}
			}
		} catch (error) {
			console.log(error);
		}
	};

useEffect(() => {
    if (video !== undefined && audio !== undefined) {
        getUserMedia();
    }
    // getUserMedia intentionally omitted because this effect
    // should run only when video/audio state changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [video, audio]);

	let getMedia = () => {
		setVideo(videoAvailable);
		setAudio(audioAvailable);
		connectToSocketServer();
	};

	let getUserMediaSuccess = (stream) => {
		try {
			window.localStream.getTracks().forEach((track) => track.stop());
		} catch (e) {
			console.log(e);
		}

		window.localStream = stream;
		if (localVideoref.current) {
			localVideoref.current.srcObject = stream;
		}

		for (let id in connections) {
			if (id === socketIdRef.current) continue;

			connections[id].addStream(window.localStream);

			connections[id].createOffer().then((description) => {
				connections[id]
					.setLocalDescription(description)
					.then(() => {
						socketRef.current.emit(
							"signal",
							id,
							JSON.stringify({
								sdp: connections[id].localDescription,
							}),
						);
					})
					.catch((e) => console.log(e));
			});
		}

		stream.getTracks().forEach(
			(track) =>
				(track.onended = () => {
					setVideo(false);
					setAudio(false);

					try {
						let tracks =
							localVideoref.current.srcObject.getTracks();
						tracks.forEach((track) => track.stop());
					} catch (e) {
						console.log(e);
					}

					let blackSilence = (...args) =>
						new MediaStream([black(...args), silence()]);
					window.localStream = blackSilence();
					if (localVideoref.current) {
						localVideoref.current.srcObject = window.localStream;
					}

					for (let id in connections) {
						connections[id].addStream(window.localStream);

						connections[id].createOffer().then((description) => {
							connections[id]
								.setLocalDescription(description)
								.then(() => {
									socketRef.current.emit(
										"signal",
										id,
										JSON.stringify({
											sdp: connections[id]
												.localDescription,
										}),
									);
								})
								.catch((e) => console.log(e));
						});
					}
				}),
		);
	};

	let getUserMedia = () => {
		if ((video && videoAvailable) || (audio && audioAvailable)) {
			navigator.mediaDevices
				.getUserMedia({ video: video, audio: audio })
				.then(getUserMediaSuccess)
				.catch((e) => console.log(e));
		} else {
			try {
				let tracks = localVideoref.current.srcObject.getTracks();
				tracks.forEach((track) => track.stop());
			} catch (e) {}
		}
	};

	let getDislayMediaSuccess = (stream) => {
		try {
			window.localStream.getTracks().forEach((track) => track.stop());
		} catch (e) {
			console.log(e);
		}

		window.localStream = stream;
		if (localVideoref.current) {
			localVideoref.current.srcObject = stream;
		}

		for (let id in connections) {
			if (id === socketIdRef.current) continue;

			connections[id].addStream(window.localStream);

			connections[id].createOffer().then((description) => {
				connections[id]
					.setLocalDescription(description)
					.then(() => {
						socketRef.current.emit(
							"signal",
							id,
							JSON.stringify({
								sdp: connections[id].localDescription,
							}),
						);
					})
					.catch((e) => console.log(e));
			});
		}

		stream.getTracks().forEach(
			(track) =>
				(track.onended = () => {
					setScreen(false);

					try {
						let tracks =
							localVideoref.current.srcObject.getTracks();
						tracks.forEach((track) => track.stop());
					} catch (e) {
						console.log(e);
					}

					let blackSilence = (...args) =>
						new MediaStream([black(...args), silence()]);
					window.localStream = blackSilence();
					if (localVideoref.current) {
						localVideoref.current.srcObject = window.localStream;
					}

					getUserMedia();
				}),
		);
	};

	let gotMessageFromServer = (fromId, message) => {
		var signal = JSON.parse(message);

		if (fromId !== socketIdRef.current) {
			if (signal.sdp) {
				connections[fromId]
					.setRemoteDescription(new RTCSessionDescription(signal.sdp))
					.then(() => {
						if (signal.sdp.type === "offer") {
							connections[fromId]
								.createAnswer()
								.then((description) => {
									connections[fromId]
										.setLocalDescription(description)
										.then(() => {
											socketRef.current.emit(
												"signal",
												fromId,
												JSON.stringify({
													sdp: connections[fromId]
														.localDescription,
												}),
											);
										})
										.catch((e) => console.log(e));
								})
								.catch((e) => console.log(e));
						}
					})
					.catch((e) => console.log(e));
			}

			if (signal.ice) {
				connections[fromId]
					.addIceCandidate(new RTCIceCandidate(signal.ice))
					.catch((e) => console.log(e));
			}
		}
	};

	let connectToSocketServer = () => {
		socketRef.current = io.connect(server_url, { secure: false });

		socketRef.current.on("signal", gotMessageFromServer);

		socketRef.current.on("connect", () => {
			socketRef.current.emit("join-call", window.location.href, username);
			socketIdRef.current = socketRef.current.id;

			socketRef.current.on("chat-message", addMessage);

			socketRef.current.on("user-left", (id) => {
				setVideos((videos) =>
					videos.filter((video) => video.socketId !== id),
				);
			});

			socketRef.current.on(
				"user-joined",
				(id, clients, socketToUsername) => {
					if (socketToUsername) {
						setParticipantNames(socketToUsername);
					}

					clients.forEach((socketListId) => {
						if (socketListId === socketIdRef.current) return;

						connections[socketListId] = new RTCPeerConnection(
							peerConfigConnections,
						);

						connections[socketListId].onicecandidate = function (
							event,
						) {
							if (event.candidate != null) {
								socketRef.current.emit(
									"signal",
									socketListId,
									JSON.stringify({ ice: event.candidate }),
								);
							}
						};

						connections[socketListId].onaddstream = (event) => {
							let videoExists = videoRef.current.find(
								(video) => video.socketId === socketListId,
							);

							if (videoExists) {
								setVideos((videos) => {
									const updatedVideos = videos.map((video) =>
										video.socketId === socketListId
											? { ...video, stream: event.stream }
											: video,
									);
									videoRef.current = updatedVideos;
									return updatedVideos;
								});
							} else {
								let newVideo = {
									socketId: socketListId,
									stream: event.stream,
									autoplay: true,
									playsinline: true,
								};

								setVideos((videos) => {
									const updatedVideos = [...videos, newVideo];
									videoRef.current = updatedVideos;
									return updatedVideos;
								});
							}
						};

						if (
							window.localStream !== undefined &&
							window.localStream !== null
						) {
							connections[socketListId].addStream(
								window.localStream,
							);
						} else {
							let blackSilence = (...args) =>
								new MediaStream([black(...args), silence()]);
							window.localStream = blackSilence();
							connections[socketListId].addStream(
								window.localStream,
							);
						}
					});

					if (id === socketIdRef.current) {
						for (let id2 in connections) {
							if (id2 === socketIdRef.current) continue;

							try {
								connections[id2].addStream(window.localStream);
							} catch (e) {}

							connections[id2]
								.createOffer()
								.then((description) => {
									connections[id2]
										.setLocalDescription(description)
										.then(() => {
											socketRef.current.emit(
												"signal",
												id2,
												JSON.stringify({
													sdp: connections[id2]
														.localDescription,
												}),
											);
										})
										.catch((e) => console.log(e));
								});
						}
					}
				},
			);
		});
	};

	let silence = () => {
		let ctx = new AudioContext();
		let oscillator = ctx.createOscillator();
		let dst = oscillator.connect(ctx.createMediaStreamDestination());
		oscillator.start();
		ctx.resume();
		return Object.assign(dst.stream.getAudioTracks()[0], {
			enabled: false,
		});
	};

	let black = ({ width = 640, height = 480 } = {}) => {
		let canvas = Object.assign(document.createElement("canvas"), {
			width,
			height,
		});
		canvas.getContext("2d").fillRect(0, 0, width, height);
		let stream = canvas.captureStream();
		return Object.assign(stream.getVideoTracks()[0], { enabled: false });
	};

	let handleVideo = () => {
		setVideo(!video);
	};
	let handleAudio = () => {
		setAudio(!audio);
	};

useEffect(() => {
    if (screen !== undefined) {
        getDislayMedia();
    }
    // getDislayMedia intentionally omitted because this effect
    // should run only when screen state changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [screen]);

	let handleScreen = () => {
		setScreen(!screen);
	};

	let handleEndCall = () => {
		try {
			let tracks = localVideoref.current.srcObject.getTracks();
			tracks.forEach((track) => track.stop());
		} catch (e) {}
		window.location.href = "/";
	};

	const addMessage = (data, sender, socketIdSender) => {
		setMessages((prevMessages) => [
			...prevMessages,
			{ sender: sender, data: data },
		]);
		if (socketIdSender !== socketIdRef.current) {
			setNewMessages((prevNewMessages) => prevNewMessages + 1);
		}
	};

	let sendMessage = () => {
		if (!message || !message.trim()) return;
		socketRef.current.emit("chat-message", message, username);
		setMessage("");
	};

	let connect = () => {
		if (!username || !username.trim()) {
			setSnackbarMessage("Please enter your name first.");
			setSnackbarOpen(true);
			return;
		}
		setAskForUsername(false);
		getMedia();
	};

	const copyMeetingLink = () => {
		navigator.clipboard.writeText(window.location.href);
		setSnackbarMessage("Meeting link copied to clipboard!");
		setSnackbarOpen(true);
	};

	const getInitials = (name) => {
		if (!name) return "?";
		return name
			.split(" ")
			.map((n) => n[0])
			.join("")
			.toUpperCase()
			.slice(0, 2);
	};

	const getMeetingCode = () => {
		return window.location.pathname.substring(1);
	};

	// Determine grid size class depending on total participants (You + others)
	const getGridClass = (totalCount) => {
		if (totalCount <= 1) return styles.grid1;
		if (totalCount === 2) return styles.grid2;
		if (totalCount <= 4) return styles.grid3;
		if (totalCount <= 6) return styles.grid5;
		return styles.gridMany;
	};

	const totalParticipants = 1 + videos.length;
	const gridClass = getGridClass(totalParticipants);

	return (
		<Box className={styles.meetVideoContainer}>
			{askForUsername === true ? (
				// LOBBY PRE-JOIN PHASE
				<Box className={styles.lobbyShell}>
					<Container maxWidth="md">
						<Grid
							container
							spacing={4}
							alignItems="center"
							justifyContent="center"
						>
							{/* Left Panel: Join Controls */}
							<Grid item xs={12} md={6}>
								<Paper
									elevation={4}
									className={styles.lobbyCard}
								>
									<Stack spacing={3}>
										<Stack
											direction="row"
											spacing={1.5}
											alignItems="center"
										>
											<Box
												className={styles.lobbyMark}
												aria-hidden="true"
											/>
											<Box>
												<Typography
													variant="h4"
													fontWeight={500}
													sx={{ color: "#ffffff" }}
												>
													Ready to join?
												</Typography>
												<Typography
													color="text.secondary"
													variant="body2"
												>
													Enter your name to connect
													to this call.
												</Typography>
											</Box>
										</Stack>

										<TextField
											id="lobby-username"
											label="Your name"
											value={username}
											onChange={(e) =>
												setUsername(e.target.value)
											}
											placeholder="e.g. Aakash"
											fullWidth
											autoFocus
											variant="outlined"
											onKeyDown={(e) => {
												if (e.key === "Enter")
													connect();
											}}
											sx={{
												"& .MuiOutlinedInput-root": {
													backgroundColor:
														"rgba(255,255,255,0.03)",
												},
											}}
										/>

										<Button
											variant="contained"
											size="large"
											onClick={connect}
											startIcon={<MeetingRoomIcon />}
											sx={{
												py: 1.5,
												fontSize: "1rem",
												borderRadius: 2,
											}}
										>
											Join now
										</Button>

										<Divider
											sx={{
												borderColor:
													"rgba(255,255,255,0.08)",
											}}
										/>

										<Stack
											direction="row"
											spacing={1}
											flexWrap="wrap"
											useFlexGap
										>
											<Chip
												icon={<TipsAndUpdatesIcon />}
												label="Keep mic muted when speaking"
												variant="outlined"
												sx={{
													borderColor:
														"rgba(255,255,255,0.08)",
													color: "text.secondary",
												}}
											/>
										</Stack>
									</Stack>
								</Paper>
							</Grid>

							{/* Right Panel: Video Preview */}
							<Grid item xs={12} md={6}>
								<Paper
									elevation={4}
									className={styles.previewCard}
								>
									<Typography
										variant="h6"
										fontWeight={500}
										sx={{
											mb: 1,
											alignSelf: "flex-start",
											color: "#ffffff",
										}}
									>
										Camera preview
									</Typography>

									<Box className={styles.previewFrame}>
										{video ? (
											<video
												ref={localVideoref}
												autoPlay
												muted
											/>
										) : (
											<Box
												className={
													styles.lobbyPreviewPlaceholder
												}
											>
												<Avatar
													sx={{
														width: 80,
														height: 80,
														fontSize: "2.5rem",
														bgcolor:
															"rgba(255, 255, 255, 0.05)",
														border: "1px solid rgba(255, 255, 255, 0.1)",
													}}
												>
													{getInitials(username) ||
														"?"}
												</Avatar>
												<Typography
													variant="body2"
													color="text.secondary"
												>
													Camera is turned off
												</Typography>
											</Box>
										)}

										<Box
											className={
												styles.lobbyPreviewControls
											}
										>
											<Tooltip
												title={
													audio
														? "Mute Microphone"
														: "Unmute Microphone"
												}
											>
												<IconButton
													onClick={handleAudio}
													className={
														audio
															? styles.dockButton
															: styles.dockButtonMuted
													}
													size="medium"
												>
													{audio ? (
														<MicIcon />
													) : (
														<MicOffIcon />
													)}
												</IconButton>
											</Tooltip>
											<Tooltip
												title={
													video
														? "Turn Camera Off"
														: "Turn Camera On"
												}
											>
												<IconButton
													onClick={handleVideo}
													className={
														video
															? styles.dockButton
															: styles.dockButtonMuted
													}
													size="medium"
												>
													{video ? (
														<VideocamIcon />
													) : (
														<VideocamOffIcon />
													)}
												</IconButton>
											</Tooltip>
										</Box>
									</Box>
								</Paper>
							</Grid>
						</Grid>
					</Container>
				</Box>
			) : (
				// IN-CALL MEETING PHASE
				<>
					<Box className={styles.meetMainLayout}>
						{/* Video Area Grid */}
						<div className={styles.videoArea}>
							<div className={styles.videoGrid}>
								{/* Local video card */}
								<div
									className={`${styles.videoTile} ${gridClass}`}
								>
									<div className={styles.tileLabel}>You</div>
									{video ? (
										<video
											ref={localVideoref}
											autoPlay
											muted
											className={styles.videoTileMirrored}
										/>
									) : (
										<Box
											className={styles.avatarPlaceholder}
										>
											<Avatar
												sx={{
													width: 80,
													height: 80,
													fontSize: "2rem",
													bgcolor: "#F97316",
													color: "#121212",
													fontWeight: 600,
												}}
											>
												{getInitials(username)}
											</Avatar>
										</Box>
									)}
								</div>

								{/* Remote videos */}
								{videos.map((videoObj) => {
									const name =
										participantNames[videoObj.socketId] ||
										"Participant";
									const isVideoEnabled =
										videoObj.stream?.getVideoTracks()[0]
											?.enabled !== false;

									return (
										<div
											className={`${styles.videoTile} ${gridClass}`}
											key={videoObj.socketId}
										>
											<div className={styles.tileLabel}>
												{name}
											</div>
											{isVideoEnabled ? (
												<video
													data-socket={
														videoObj.socketId
													}
													ref={(ref) => {
														if (
															ref &&
															videoObj.stream
														) {
															ref.srcObject =
																videoObj.stream;
														}
													}}
													autoPlay
												/>
											) : (
												<Box
													className={
														styles.avatarPlaceholder
													}
												>
													<Avatar
														sx={{
															width: 80,
															height: 80,
															fontSize: "2rem",
															bgcolor: "#F97316",
															color: "#121212",
															fontWeight: 600,
														}}
													>
														{getInitials(name)}
													</Avatar>
												</Box>
											)}
										</div>
									);
								})}

								{/* Special helper when alone in call */}
								{videos.length === 0 && (
									<Box className={styles.emptyGridDetails}>
										<Typography
											variant="h6"
											fontWeight={400}
											color="text.secondary"
										>
											You are the only one in the call
										</Typography>
										<Typography
											variant="body2"
											color="text.secondary"
											sx={{ opacity: 0.7 }}
										>
											Share the meeting link to invite
											others.
										</Typography>
										<Button
											variant="outlined"
											startIcon={<ContentCopyIcon />}
											onClick={copyMeetingLink}
											sx={{
												border: "1px solid rgba(255, 255, 255, 0.15)",
												borderRadius: 2,
											}}
										>
											Copy link
										</Button>
									</Box>
								)}
							</div>
						</div>

						{/* Collapsible Chat Drawer */}
						{showModal && (
							<Box className={styles.sidePanel}>
								<div className={styles.chatContainer}>
									<div className={styles.chatHeader}>
										<h3>In-call messages</h3>
										<IconButton
											onClick={() => setModal(false)}
											size="small"
										>
											<CloseIcon />
										</IconButton>
									</div>

									<div className={styles.chattingDisplay}>
										{messages.length !== 0 ? (
											messages.map((item, index) => {
												const isMe =
													item.sender === username;
												return (
													<div
														className={`${styles.msgRow} ${isMe ? styles.msgRowMe : ""}`}
														key={index}
													>
														<p
															className={
																styles.msgSender
															}
														>
															{isMe
																? "You"
																: item.sender}
														</p>
														<p
															className={`${styles.msgBubble} ${isMe ? styles.msgBubbleMe : ""}`}
														>
															{item.data}
														</p>
													</div>
												);
											})
										) : (
											<Box
												sx={{
													display: "grid",
													placeItems: "center",
													height: "100%",
													color: "text.secondary",
													opacity: 0.6,
													fontSize: "0.9rem",
												}}
											>
												Messages sent here can be seen
												by everyone in this call.
											</Box>
										)}
									</div>

									<div className={styles.chattingArea}>
										<TextField
											fullWidth
											value={message}
											onChange={(e) =>
												setMessage(e.target.value)
											}
											placeholder="Send a message..."
											variant="outlined"
											size="small"
											onKeyDown={(e) => {
												if (e.key === "Enter")
													sendMessage();
											}}
											sx={{
												"& .MuiOutlinedInput-root": {
													borderRadius: 999,
													backgroundColor:
														"rgba(255,255,255,0.03)",
												},
											}}
										/>
										<IconButton
											onClick={sendMessage}
											color="primary"
											disabled={!message.trim()}
										>
											<SendIcon />
										</IconButton>
									</div>
								</div>
							</Box>
						)}
					</Box>

					{/* Bottom Action bar */}
					<Box className={styles.bottomBar}>
						{/* Meeting Info */}
						<div className={styles.meetingInfo}>
							<Typography className={styles.meetingCode}>
								{getMeetingCode()}
							</Typography>
							<Typography className={styles.meetingClock}>
								{clockTime}
							</Typography>
						</div>

						{/* Control Buttons */}
						<div className={styles.controlDock}>
							<Tooltip
								title={
									audio
										? "Mute Microphone"
										: "Unmute Microphone"
								}
							>
								<IconButton
									onClick={handleAudio}
									className={
										audio
											? styles.dockButton
											: styles.dockButtonMuted
									}
								>
									{audio ? <MicIcon /> : <MicOffIcon />}
								</IconButton>
							</Tooltip>

							<Tooltip
								title={
									video ? "Turn Camera Off" : "Turn Camera On"
								}
							>
								<IconButton
									onClick={handleVideo}
									className={
										video
											? styles.dockButton
											: styles.dockButtonMuted
									}
								>
									{video ? (
										<VideocamIcon />
									) : (
										<VideocamOffIcon />
									)}
								</IconButton>
							</Tooltip>

							{screenAvailable === true && (
								<Tooltip
									title={
										screen
											? "Stop Sharing Screen"
											: "Share Screen"
									}
								>
									<IconButton
										onClick={handleScreen}
										className={
											screen
												? styles.dockButtonActive
												: styles.dockButton
										}
									>
										{screen ? (
											<StopScreenShareIcon />
										) : (
											<ScreenShareIcon />
										)}
									</IconButton>
								</Tooltip>
							)}

							<Tooltip title="Toggle Chat">
								<Badge
									badgeContent={newMessages}
									color="primary"
									sx={{
										"& .MuiBadge-badge": {
											backgroundColor: "#F97316",
											color: "#121212",
											fontWeight: 600,
										},
									}}
								>
									<IconButton
										onClick={() => {
											setModal(!showModal);
											setNewMessages(0);
										}}
										className={
											showModal
												? styles.dockButtonActive
												: styles.dockButton
										}
									>
										<ChatIcon />
									</IconButton>
								</Badge>
							</Tooltip>

							<Tooltip title="Leave Call">
								<IconButton
									onClick={handleEndCall}
									className={styles.dockButtonEnd}
								>
									<CallEndIcon
										sx={{ transform: "rotate(135deg)" }}
									/>
								</IconButton>
							</Tooltip>
						</div>

						{/* Extra spacer / details trigger in Meet */}
						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: "0.8rem",
							}}
						>
							<Tooltip title="Show details">
								<IconButton
									onClick={copyMeetingLink}
									className={styles.dockButton}
								>
									<ContentCopyIcon size="small" />
								</IconButton>
							</Tooltip>
							<Chip
								icon={
									<PeopleIcon
										style={{
											color: "#ffffff",
											fontSize: "1rem",
										}}
									/>
								}
								label={totalParticipants}
								size="small"
								sx={{
									backgroundColor: "#202124",
									color: "#ffffff",
									border: "1px solid rgba(255, 255, 255, 0.08)",
								}}
							/>
						</div>
					</Box>
				</>
			)}

			<Snackbar
				open={snackbarOpen}
				autoHideDuration={3000}
				onClose={() => setSnackbarOpen(false)}
				message={snackbarMessage}
			/>
		</Box>
	);
}
